import React, { useState } from "react";
import ct from "class-types.macro";
import { z } from "zod";
import SubmissionResult from "~/Brochure/SubmissionResult/SubmissionResult";
import ValidatedForm from "~/common/Form/ValidatedForm";

import EmailSignupForm from "./EmailSignupForm";

const schema = z.object({
  EmailAddress: z
    .string()
    .nonempty("Email is required")
    .email("Invalid email format"),
});

function EmailSignup() {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [successMessage, setSuccessMessage] = useState<string>("");
  const [statusCode, setStatusCode] = useState<number>();
  const [submissionResponse, setSubmissionResponse] = useState<
    SubmissionResult | "GeneralFailure"
  >();

  const httpOk = 200;

  return (
    <div
      data-component="newitem-signup"
      className={ct(
        "rounded",
        "my-4",
        "p-5",
        "text-white",
        "w-4/5",
        "sm:my-0",
        "sm:w-auto",
      )}
      style={{ backgroundColor: "rgb(0 0 0 / 29%)" }}
    >
      <p
        className={ct(
          "font-bold",
          "text-xl",
          "leading-tight",
          "mb-2",
          "md:mb-4",
        )}
      >
        Sign up for updates on new products
      </p>
      {statusCode === httpOk ? (
        <p>{successMessage}</p>
      ) : (
        <>
          <ValidatedForm<SubmissionResult>
            validationSchema={schema}
            submissionUrl="/api/productlisting/products/new/signup/"
            beforeSubmit={() => {
              setIsSubmitting(true);
              setSubmissionResponse(undefined);
              setStatusCode(undefined);
            }}
            onSubmitSuccess={(response) => {
              setIsSubmitting(false);
              setSuccessMessage(response.message);
              setStatusCode(response.statusCode);
            }}
            onSubmitError={(response) => {
              setIsSubmitting(false);
              setSubmissionResponse(response);
            }}
          >
            <EmailSignupForm
              isSubmitting={isSubmitting}
              submissionResponse={submissionResponse}
            />
          </ValidatedForm>
        </>
      )}
    </div>
  );
}

export default EmailSignup;
